import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithubSquare} from 'react-icons/fa'
import {FaInstagramSquare} from 'react-icons/fa'
import {FaFacebookSquare} from 'react-icons/fa'

function HeaderSocials() {
  return (
    <div className="header__socials">
        <a href="https://www.linkedin.com/in/sean1991/" target="_blank"><BsLinkedin /></a>
        <a href="https://github.com/Choi-Sean/" target="_blank"><FaGithubSquare/></a>
        <a href="https://www.instagram.com/sean_choi91/" target="_blank"><FaInstagramSquare /></a>
        <a href="https://www.facebook.com/choisean1991/" target="_blank"><FaFacebookSquare /></a>
    </div>
  )
}

export default HeaderSocials